import { Add, Search } from '@mui/icons-material'
import { Box, IconButton, Paper, TextField } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { CreateIncidentReport } from 'components/incident-reports'
import {
  Operations as IncidentReportOperations,
  operations as incidentReportOperations
} from 'states/dux/incident-report/operations'
import { Payload as IncidentReportPayload } from 'states/dux/incident-report/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  incidentReport: IncidentReportPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    incidentReport: IncidentReportOperations
  }
}

type AppProps = StateProps & DispatchProps

const MobileIncidentReportsSearchBarFC: React.FC<any> = (props: AppProps) => {
  const { theme, operations } = props
  const [keyword, setKeyword] = React.useState('')

  const getSearchFilter = (): string => {
    if (keyword !== '') {
      return `?search=${keyword}`
    }

    return ''
  }

  const getFilterString = (): string => {
    return getSearchFilter()
  }

  const onSubmit = (): void => {
    const filterStr = getFilterString()

    operations.incidentReport.loading(true)

    // Fetch filtered Data
    void get('/report/' + filterStr)
      .then(data => {
        const parsedData = data.map((report: Object) => {
          return objectifyDateStringFields(report)
        })
        operations.incidentReport.set(parsedData)
        operations.incidentReport.loading(false)
      })
      .catch(err => {
        console.log(err)
        operations.incidentReport.loading(false)
      })
  }

  return (
    <Box>
      <Paper elevation={8} sx={{ borderRadius: '12px', width: 'inherit' }}>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <TextField
            fullWidth
            type={'text'}
            placeholder={'Report title...'}
            value={keyword}
            onChange={event => setKeyword(event.currentTarget.value)}
            InputProps={{
              startAdornment: <Search />
            }}
            sx={{
              margin: 1
            }}
          />
          <Box flexGrow={1} />
          <IconButton onClick={() => onSubmit()}>
            <Search />
          </IconButton>
          <Box
            paddingLeft={1}
            borderRight={1}
            height={'56px'}
            color={theme.secondaryColor}
          />
          <Box
            paddingRight={1}
            borderLeft={1}
            height={'56px'}
            color={theme.secondaryColor}
          />
          <CreateIncidentReport
            title={'New'}
            buttonProps={{ startIcon: <Add /> }}
            useIconButton={true}
          />
        </Box>
      </Paper>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    incidentReport: state.incidentReport
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  incidentReport: incidentReportOperations
})

const MobileIncidentReportsSearchBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileIncidentReportsSearchBarFC)

export default MobileIncidentReportsSearchBar
